const { useEffect, useState } = require('react');
const StarterRefresh = require('utils/conversationStarterRefresh');

exports.usePersonalizedConversationStarters = ({ enabled, viewerId, schoolId, peerId, token, revision, fetchStarters, fallback }) => {

    const [refreshVersion, setRefreshVersion] = useState(0);
    const key = JSON.stringify([viewerId, schoolId, peerId, token, revision, refreshVersion]);
    const [response, setResponse] = useState(null);

    useEffect(() => {

        if (!enabled) { return undefined; }
        const refresh = () => setRefreshVersion((value) => value + 1);
        window.addEventListener(StarterRefresh.eventName, refresh);
        window.addEventListener('focus', refresh);
        return () => {
            window.removeEventListener(StarterRefresh.eventName, refresh);
            window.removeEventListener('focus', refresh);
        };
    }, [enabled]);

    useEffect(() => {

        let active = true;
        setResponse(null);

        if (enabled && viewerId && schoolId && peerId && token) {
            Promise.resolve().then(() => fetchStarters({ peerId, token })).then((result) => {

                if (active) {
                    setResponse({ key, result });
                }
            }).catch(() => {

                if (active) {
                    setResponse({ key, result: null });
                }
            });
        }

        return () => { active = false; };
    }, [enabled, viewerId, schoolId, peerId, token, revision, fetchStarters, key]);

    if (enabled && response?.key === key && response.result?.enabled && Array.isArray(response.result.starters)) {
        return { starters: response.result.starters, personalized: true };
    }

    return { starters: fallback || [], personalized: false };
};
